import { useEffect, useState } from 'react';

// icons
import { ReactComponent as CaretIcon } from '../../../../../assets/svg/bottom-arrow.svg';
import styles from './OtpItem.module.css';
import useOtpItem from './useOtpItem';

const OtpItem = ({ order, data }) => {
  const [counter, setCounter] = useState(data.otp.otp_time === 'expired' ? 0 : data.otp.otp_time);
  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const date = new Date(null);
  date.setSeconds(counter);
  const label_value = date.toISOString().substr(14, 5);

  const [descriptionRef, show, setShow, descriptionHeight] = useOtpItem(data);

  return (
    <div className={styles.OtpIconContainer}>
      <div className={styles.OtpItemContainer} onClick={() => setShow(!show)}>
        <div className={styles.Header}>
          <div className={`${styles.Caret} ${show ? styles.Active : ''}`}>
            <CaretIcon className={styles.CaretIcon} />
          </div>
          <div className={styles.OrderNumber}>
            <span>شماره سفارش</span>
            <span>{order}</span>
          </div>
        </div>
        <div className={styles.Header}>
          <div className={styles.OrderNumber}>
            <span>کد یکبار مصرف</span>
            <div className={styles.OtpCountDown} style={{ marginLeft: '33px' }}>
              <span>{data.otp.otp_code}</span>
            </div>
          </div>
        </div>
        <div className={styles.Header}>
          <div className={styles.OrderNumber}>
            <span>انقضا</span>
            <div className={styles.OtpCode} style={{ marginLeft: '33px' }}>
              {label_value}
            </div>
          </div>
        </div>

        <div
          className={`${styles.DescriptionContainer} ${show ? styles.Show : ''}`}
          style={{ height: show ? descriptionHeight : 0 }}>
          <div ref={descriptionRef} className={styles.Description}>
            {data.orders.map((orderItem, i) => (
              <div key={i} className={styles.products}>
                <div>
                  <span className="w-130">
                    <span className="pa-l-5">{orderItem.product}</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpItem;
